import React from 'react';

const Auction = () => {
  return (
    <div className="auction-coming-soon">
      <h2>Auction System</h2>
      <p>Coming Soon!</p>
        
    </div>
  );
};

export default Auction;